import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e140b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = { class: "mediaclText" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sex" }, "男，3岁"),
  /*#__PURE__*/_createElementVNode("div", { class: "clue" }, "线索:现病史"),
  /*#__PURE__*/_createElementVNode("div", { class: "mainTail" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "主诉AD症状加重"),
      /*#__PURE__*/_createElementVNode("li", null, "周身红斑、丘疹、严重渗出2月")
    ])
  ])
], -1))
const _hoisted_7 = { class: "right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clue" }, "线索:既往病史")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxTail" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "3月龄初发，诊断为特应性皮炎。外用润肤霜、注意护理可缓解。"),
    /*#__PURE__*/_createElementVNode("li", null, " 2022年9月-2023年2月加重。外用少量激素（地奈德乳膏）未缓解。曾在公园草地玩耍，之后加重，四肢明显严重渗出，瘙痒难耐，每晚睡眠连续无法超过4小时，严重影响睡眠。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 既往体健，偶有腹泻。足月顺产。混合喂养。生长发育正常。每日牛奶200ml，常食甜食、零食。 ")
  ])
], -1))
const _hoisted_10 = { class: "btnBox" }
const _hoisted_11 = { class: "bxs" }
const _hoisted_12 = { class: "ip" }
const _hoisted_13 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_correct = _resolveComponent("correct")!
  const _component_reason = _resolveComponent("reason")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          width: "2.1333rem",
          height: ".6667rem",
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_image, {
                width: "2.36rem",
                height: "3.5867rem",
                src: require('../assets/boy.png')
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_8,
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "2.5733rem",
            height: "4.5733rem",
            src: require('../assets/bxs.png')
          }, null, 8, ["onClick", "src"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "2.5733rem",
            height: "2.5733rem",
            src: require('../assets/jixu.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 1,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 2,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 1 })
  ], 64))
}